import type { UseQueryOptions } from '@tanstack/react-query';

import { getNotifications, type KyInstance, type Notification } from '@enterprise/api';
import { SECOND } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { notificationsQueryKeys } from '@feat/notifications/common/notifications-query-keys';

export const createNotificationsQuery = (
  instance: KyInstance
): UseQueryOptions<OperationResultWithData<Notification[]>, Error, Notification[]> => {
  return {
    queryFn: () => {
      return getNotifications(instance);
    },
    queryKey: notificationsQueryKeys.list(),
    select: (result) => {
      if (result.failure) {
        return [];
      }

      return result.data ?? [];
    },
    staleTime: 30 * SECOND,
  };
};
